
import ProductDescriptionViewCard from "./ProductDescriptionViewCard";

interface ProductDescription {
  id: number;
  type: string;
  standardMaterial: string;
  pressure: string;
  temperature: string;
  surfaceSpeed: string;
  stock: number;
  unlimited: boolean;
}

interface ProductDescriptionListProps {
  descriptions: ProductDescription[];
}

export default function ProductDescriptionList({
  descriptions,
}: ProductDescriptionListProps) {
  return (
    <div className="rounded-3xl bg-white p-8 shadow-sm">
      {/* Header */}
      <div className="mb-8 flex items-center justify-between border-b border-gray-100 pb-5">
     
        <h2 className="text-2xl font-bold text-gray-900">
          Product Specifications
        </h2>
        <span className="rounded-full bg-blue-600 px-3 py-1 text-sm font-semibold text-white">
          {descriptions.length} Item
          {descriptions.length > 1 ? "s" : ""}
        </span>
      </div>

    
      {/* Empty */}
      {descriptions.length === 0 ? (
        <div className="rounded-2xl border-2 border-dashed border-gray-300 py-20 text-center text-gray-400">
          No Specification
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                  No
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                  Type
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                  Material
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                  Pressure
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                  Temperature
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                  Surface Speed
                </th>
                <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">
                  Stock
                </th>
                <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">
                  Unlimited
                </th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-100 bg-white">
              {descriptions.map((item, index) => (
                <tr key={item.id} className="hover:bg-gray-50">
                  <td className="px-4 py-4">{index + 1}</td>
                  <td className="px-4 py-4">{item.type}</td>
                  <td className="px-4 py-4">{item.standardMaterial}</td>
                  <td className="px-4 py-4">{item.pressure}</td>
                  <td className="px-4 py-4">{item.temperature}</td>
                  <td className="px-4 py-4">{item.surfaceSpeed}</td>
                  <td className="px-4 py-4 text-center">{item.stock}</td>
                  <td className="px-4 py-4 text-center">
                    <span
                      className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${
                        item.unlimited
                          ? "bg-green-100 text-green-700"
                          : "bg-gray-100 text-gray-700"
                      }`}>
                      {item.unlimited ? "Yes" : "No"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

interface InfoItemProps {
  label: string;
  value: string;
}

function InfoItem({ label, value }: InfoItemProps) {
  return (
    <div className="flex items-center gap-4">
      <span className="w-40 font-medium text-gray-500">{label}</span>

      <span className="font-semibold text-gray-900">{value}</span>
    </div>
  );
}
